var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 19.6H9.2c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h1.6c.2 0 .4.2.4.4s-.2.4-.4.4zm2.5-4.6l-1.6 1.2c-.1.1-.3.2-.5.2s-.4-.1-.6-.2c-.2-.2-.2-.4-.2-.6V6.4c0-.7.5-1.2 1.2-1.2H16v-2c0-.7-.5-1.2-1.2-1.2H5.2C4.5 2 4 2.5 4 3.2v17.6c0 .7.5 1.2 1.2 1.2h9.6c.7 0 1.2-.5 1.2-1.2v-6h-2c-.3 0-.5.1-.7.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.2h-4c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h4c.2 0 .4.2.4.4s-.2.4-.4.4zm0 2.4h-4c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h4c.2 0 .4.2.4.4s-.2.4-.4.4zM20.4 6h-8.8c-.2 0-.4.2-.4.4v9.2l1.6-1.2c.3-.3.8-.4 1.2-.4h6.4c.2 0 .4-.2.4-.4V6.4c0-.2-.2-.4-.4-.4z"
  })));
}

export default SvgPhoneMessage;